<template>
    <div class="d-none">
        <div :id="model_id" class="modal-box">
            <div class="close-button"> <a href="#" class="modal-close white"></a> </div>
            <div class="modal-container padding0">

                <div id="test" class="form-container">

                    <div class="" style="padding: 4vw 10vw 0vw">
                        <div v-if="showSuccessMsg" class="alert alert-success">
                            Email updated successfully.
                        </div>
                        <div v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul style="color: red">
                                <li  class="alert alert-danger"  v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                        <div class="form-element">
                            <label for="current_email"  class="title">Current Email</label>
                            <input id="current_email" type="email" v-model="current_email" disabled style="color:black" required>
                        <div class="form-element">
                            <label for="email" class="title">New Email</label>
                            <input id="email" type="email" v-model="email" placeholder="Input new email" required autofocus>
                        </div>

                    </div>

                    <div class="button-container no-margin text-center" style="padding:1vw">
                        <input type="submit" id="change-email" @click="handleSubmit" class="button pink midsize mid my-3" value="Change">

                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ChangeEmailModal',
        props: ['modalId'],
        data(){
            return {
                user: null,
                email: null,
                current_email: null,
                errors: [],
                showSuccessMsg: false,
                model_id: 'change-email-'+this.modalId
            }
        },
        mounted() {
            this.errors = [];
            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
                this.current_email = this.user ? this.user.email : '';
            }
        },
        watch: {
            modalId: function (val) {
            }
        },
        methods : {
            resetForm() {
                this.email = '';
                this.errors= [];
                this.showSuccessMsg= false;
            },
            validate() {

                this.errors = [];

                if(!this.validateEmailInput(this.email)) {
                    this.errors.push("Valid email required.");
                }

                if(this.user && this.user.email == this.email && this.email != '') {
                    this.errors.push("Please input new email address.");
                }

                return this.errors.length == 0;
            },

            handleSubmit(e) {
                this.errors = [];
                this.showSuccessMsg = false;
                e.preventDefault();

                if (this.validate()) {
                    axios.post(this.apiEndPoints.changeEmail, {
                        email: this.email,
                    })
                        .then(response => {
                            // console.log(response);

                            if (response.data && response.data.status) {

                                if (response.data.status == 'success') {
                                    if (response.data.user && response.data.user.id) {
                                        this.resetUserInLocalStorage(response.data.user);
                                        this.user = response.data.user;
                                        this.$emit('reload', this.user);
                                    }
                                    this.showSuccessMsg = true;
                                } else if (response.data.message) {

                                    this.errors.push(response.data.message)
                                } else {
                                    this.errors.push('An error occurred. Please try again!')
                                }
                            }
                        })
                        .catch(error => {
                            this.$refs.recaptcha.reset();
                            console.error(error.response);

                            if (error.response && error.response.status && error.response.status == 419) {
                                this.$router.push({ name: 'sign_in' });
                            }
                        });
                } else {
                }
            }
        },
    }
</script>
